
const digest = 'dc52ef0de8049a0209fc09b71fdc6d34e4d7879d62192fba6fd3c77430be1731';
const classes = {"wrapper":"_wrapper_1x7us_1","activeDot":"_activeDot_1x7us_10","dot":"_dot_1x7us_16"};
const css = `._wrapper_1x7us_1 {
  gap: 15px;
  display: flex;
  flex-direction: row;
  border-radius: 15px;
  background-color: #f0f0f0;
  width: fit-content;
  padding: 15px 20px;
}
._wrapper_1x7us_1 ._activeDot_1x7us_10 {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: rgb(88, 79, 184);
}
._wrapper_1x7us_1 ._dot_1x7us_16 {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: rgb(198, 197, 223);
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  